<!-- ===== ANEXOS PANEL ===== -->
@if (!isSomenteLeitura) {
  <app-file-dropzone
    [uploading]="uploadingAnexo"
    [accept]="tiposArquivoAceitos"
    hint="PDF, XLSX, DOCX, CSV, TXT, PNG, JPG · até 10 MB cada"
    (filesSelected)="processFiles($event)">
  </app-file-dropzone>
}
<div class="section-title">
  <mat-icon>attach_file</mat-icon>
  <span>Arquivos do card</span>
  <span class="status-badge badge-cinza">{{ attachments.length }}</span>
</div>
@for (a of attachments; track a.idAnexo ?? a.name) {
  <div class="ced-anx-file">
    <span class="ced-anx-ico" [style.background]="kindMeta(a.kind).bg" [style.color]="kindMeta(a.kind).color">
      <mat-icon class="material-symbols-outlined">{{ kindMeta(a.kind).icon }}</mat-icon>
    </span>
    <div class="ced-anx-info">
      <div class="ced-anx-name">{{ a.name }}</div>
      <div class="ced-anx-meta">
        @if (a.whoName) {
          <span class="ced-avatar ced-anx-avatar" [style.background]="a.whoColor">{{ a.who }}</span>
        }
        <span class="ced-anx-meta-text">
          @if (a.whoName) { {{ a.whoName }} · }{{ a.when }} · <span class="ced-anx-size">{{ a.size }}</span>
        </span>
      </div>
    </div>
    <div class="ced-anx-actions">
      <button type="button" mat-icon-button class="item-remover" matTooltip="Baixar" (click)="downloadAnexo(a)">
        <mat-icon class="material-symbols-outlined">download</mat-icon>
      </button>
      @if (!isSomenteLeitura) {
        <button type="button" mat-icon-button class="btn-remover" matTooltip="Remover" (click)="deleteAnexo(a)">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      }
    </div>
  </div>
}
